import {Card} from 'shells/card/card';
import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import styles from './ai-summary.module.css';

interface Props {
    title: string;
    icon: React.ComponentType<any>;
    description: string;
}

export function AiSummary(props: Props) {
    const Icon = props.icon;

    return (
        <Card hasBorder={false} hasShadow={false} className={styles['container']}>
            <Stack spacing={4}>
                <Stack isHorizontal={true} spacing={4} alignItems='center'>
                    <Icon size={16} wrapWithDiv={false} />
                    <Body size='small' color='dark' isBold={true}>
                        {props.title}
                    </Body>
                </Stack>
                <Body color='medium' size='small'>
                    {props.description}
                </Body>
            </Stack>
        </Card>
    );
}
